export const CorePermissions = {
  Tiles: {
    FullRead: 'll-portal-backend.core.tiles.read',
  },
} as const;

export const UserPermissions = {
  User: {
    CanManageUsers: 'user.management.can-manage-users',
  },
  Deal: {
    CanCustomizeCoverages: 'user.deal.can-customize-coverages',
    CanAccessDealsDashboard: 'user.deal.deals-dashboard-view',
    CanEditLeaseDetails: 'user.deal.can-edit-lease-details',
  },
  Claim: {
    CanFileClaim: 'user.claim.can-file-claim',
    CanViewReport: 'user.claim.powerbi-report-view',
  },
  Invite: {
    CanInviteRenter: 'user.invite.can-send-invite',
  },
  Properties: {
    CanEnrollProperty: 'user.property.can-enroll-property',
  },
  Zgri: {
    UseLandlordFeatures: 'user.zgri.use-landlord-features',
    UseOpsFeatures: 'user.zgri.use-ops-features',
    UseExperimentalFeatures: 'user.zgri.use-experimental-features',
  },
} as const;
